<div class="p-2">
  <div class="sub-bg">
    <div class="container-fluid">
      <div class="form-group row">
        <form [formGroup]="formdata" autocomplete="off">
          <!-- ─── Row 1: Basic Info ─────────────────────────────────────────── -->
          <div class="row mt-3">
            <!-- Company -->
            <div class="col-md-3">
              <label class="form-label required">{{
                "Company" | translate
              }}</label>
              <ng-select
                [items]="companyList"
                bindLabel="company_name"
                bindValue="id"
                [clearable]="false"
                [placeholder]="'Select Company' | translate"
                formControlName="company"
                [ngClass]="{ 'is-invalid': isInvalid('company') }"
              >
              </ng-select>
              <app-validation-error
                [control]="formdata.get('company')"
                fieldName="Company"
                [submit]="saveClick"
              ></app-validation-error>
            </div>

            <!-- Name -->
            <div class="col-md-3">
              <label class="form-label required" for="name">{{
                "Name" | translate
              }}</label>
              <input
                type="text"
                id="name"
                class="form-control"
                [placeholder]="'Enter Name' | translate"
                formControlName="name"
                [ngClass]="{ 'is-invalid': isInvalid('name') }"
              />
              <app-validation-error
                [control]="formdata.get('name')"
                fieldName="Name"
                [submit]="saveClick"
              ></app-validation-error>
            </div>

            <!-- Type -->
            <div class="col-md-2">
              <label class="form-label required" for="type">{{
                "Type" | translate
              }}</label>
              <ng-select
                [items]="typeOption"
                bindLabel="label"
                bindValue="value"
                [clearable]="false"
                [placeholder]="'Select Type' | translate"
                formControlName="type"
                [ngClass]="{ 'is-invalid': isInvalid('type') }"
              ></ng-select>
              <app-validation-error
                [control]="formdata.get('type')"
                fieldName="Type"
                [submit]="saveClick"
              ></app-validation-error>
            </div>

            <!-- Branch Name -->
            <div class="col-md-2">
              <label class="form-label" for="branch_name">{{
                "Branch Name" | translate
              }}</label>
              <input
                type="text"
                id="branch_name"
                class="form-control"
                [placeholder]="'e.g. Anna Nagar' | translate"
                formControlName="branch_name"
              />
            </div>

            <!-- Location -->
            <div class="col-md-2">
              <label class="form-label" for="location_name">{{
                "Location" | translate
              }}</label>
              <input
                type="text"
                id="location_name"
                class="form-control"
                [placeholder]="'e.g. Chennai' | translate"
                formControlName="location_name"
              />
            </div>
          </div>

          <!-- ─── Row 2: API Connection ─────────────────────────────────────── -->
          <div class="row mt-3">
            <!-- API URL -->
            <div class="col-md-5">
              <label class="form-label required" for="api_url">{{
                "API Endpoint URL" | translate
              }}</label>
              <input
                type="text"
                id="api_url"
                class="form-control"
                placeholder="https://vendor-api.com/api/punches"
                formControlName="api_url"
                [ngClass]="{ 'is-invalid': isInvalid('api_url') }"
              />
              <app-validation-error
                [control]="formdata.get('api_url')"
                fieldName="API URL"
                [submit]="saveClick"
              ></app-validation-error>
            </div>

            <!-- HTTP Method -->
            <div class="col-md-2">
              <label class="form-label" for="http_method">{{
                "HTTP Method" | translate
              }}</label>
              <ng-select
                [items]="httpMethodOptions"
                bindLabel="label"
                bindValue="value"
                [clearable]="false"
                formControlName="http_method"
              ></ng-select>
            </div>

            <!-- API Key -->
            <div class="col-md-3">
              <label class="form-label" for="api_key">{{
                "API Key" | translate
              }}</label>
              <input
                type="text"
                id="api_key"
                class="form-control"
                [placeholder]="'Vendor API key' | translate"
                formControlName="api_key"
              />
            </div>

            <!-- Device IDs -->
            <div class="col-md-6 mt-3">
              <label class="form-label required">{{
                "Device Id (Press Enter to add)" | translate
              }}</label>
              <div
                class="form-control d-flex flex-wrap align-items-center gap-2"
                [ngClass]="{ 'is-invalid': isInvalid('device_ids') }"
                (click)="inputRef.focus()"
              >
                <span
                  *ngFor="
                    let item of formdata.get('device_ids')?.value;
                    let i = index
                  "
                  class="margin_top email-badge text-white d-flex align-items-center"
                >
                  {{ item }}
                  <i
                    class="fa-solid fa-xmark ms-2"
                    (click)="removeItem(i)"
                    style="cursor: pointer"
                  ></i>
                </span>
                <input
                  #inputRef
                  type="text"
                  class="border-0 flex-grow-1 p-0"
                  maxlength="30"
                  style="min-width: 120px; outline: none"
                  formControlName="device_id_input"
                  (keydown.enter)="addItem()"
                  [placeholder]="'Type and press Enter' | translate"
                />
              </div>
              <app-validation-error
                [control]="formdata.get('device_id_input')"
                fieldName="Device Id"
                [submit]="saveClick"
              ></app-validation-error>
            </div>
          </div>

          <!-- ─── Row 3: Auth Configuration ─────────────────────────────────── -->
          <div class="row mt-3">
            <div class="col-12">
              <h6 class="section-label mb-2">
                {{ "Authentication" | translate }}
              </h6>
            </div>

            <!-- Auth Type -->
            <div class="col-md-3">
              <label class="form-label">{{ "Auth Type" | translate }}</label>
              <ng-select
                [items]="authTypeOptions"
                bindLabel="label"
                bindValue="value"
                [clearable]="true"
                [placeholder]="'None' | translate"
                formControlName="auth_type"
              ></ng-select>
            </div>

            <!-- Bearer Token -->
            <ng-container *ngIf="authType === 'bearer'">
              <div class="col-md-4">
                <label class="form-label required">{{
                  "Bearer Token" | translate
                }}</label>
                <input
                  type="text"
                  class="form-control"
                  [placeholder]="'Paste token here' | translate"
                  formControlName="auth_token"
                />
              </div>
            </ng-container>

            <!-- Basic Auth -->
            <ng-container *ngIf="authType === 'basic'">
              <div class="col-md-3">
                <label class="form-label required">{{
                  "Username" | translate
                }}</label>
                <input
                  type="text"
                  class="form-control"
                  [placeholder]="'Username' | translate"
                  formControlName="auth_username"
                />
              </div>
              <div class="col-md-3">
                <label class="form-label required">{{
                  "Password" | translate
                }}</label>
                <input
                  type="password"
                  class="form-control"
                  [placeholder]="'Password' | translate"
                  formControlName="auth_password"
                  autocomplete="new-password"
                />
              </div>
            </ng-container>

            <!-- API Key Header -->
            <ng-container *ngIf="authType === 'api_key'">
              <div class="col-md-3">
                <label class="form-label required">{{
                  "API Key Value" | translate
                }}</label>
                <input
                  type="text"
                  class="form-control"
                  [placeholder]="'your-api-key' | translate"
                  formControlName="auth_key_value"
                />
              </div>
              <div class="col-md-3">
                <label class="form-label required">{{
                  "Header Name" | translate
                }}</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="x-api-key"
                  formControlName="auth_header_name"
                />
              </div>
            </ng-container>
          </div>

          <!-- ─── Row 4: Schedule Configuration ────────────────────────────── -->
          <div class="row mt-3">
            <div class="col-12">
              <h6 class="section-label mb-2">
                {{ "Fetch Schedule" | translate }}
              </h6>
            </div>

            <!-- Schedule Type -->
            <div class="col-md-3">
              <label class="form-label">{{
                "Schedule Type" | translate
              }}</label>
              <ng-select
                [items]="scheduleTypeOptions"
                bindLabel="label"
                bindValue="value"
                [clearable]="true"
                [placeholder]="'Select schedule' | translate"
                formControlName="schedule_type"
              ></ng-select>
            </div>

            <!-- Every N Minutes -->
            <ng-container *ngIf="scheduleType === 'every_n_minutes'">
              <div class="col-md-3">
                <label class="form-label required">{{
                  "Fetch every ___ minutes" | translate
                }}</label>
                <input
                  type="number"
                  class="form-control"
                  min="1"
                  max="59"
                  formControlName="schedule_minutes"
                />
                <app-validation-error
                  [control]="formdata.get('schedule_minutes')"
                  fieldName="Minutes"
                  [submit]="saveClick"
                ></app-validation-error>
              </div>
            </ng-container>

            <!-- Every N Hours -->
            <ng-container *ngIf="scheduleType === 'every_n_hours'">
              <div class="col-md-3">
                <label class="form-label required">{{
                  "Fetch every ___ hours" | translate
                }}</label>
                <input
                  type="number"
                  class="form-control"
                  min="1"
                  max="23"
                  formControlName="schedule_hours"
                />
                <app-validation-error
                  [control]="formdata.get('schedule_hours')"
                  fieldName="Hours"
                  [submit]="saveClick"
                ></app-validation-error>
              </div>
            </ng-container>

            <!-- Custom Cron -->
            <ng-container *ngIf="scheduleType === 'custom_cron'">
              <div class="col-md-4">
                <label class="form-label required">{{
                  "Cron Expression" | translate
                }}</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="*/15 * * * *"
                  formControlName="schedule_cron"
                />
              </div>
            </ng-container>

            <!-- Fixed Times -->
            <ng-container *ngIf="scheduleType === 'fixed_times'">
              <div class="col-md-5">
                <label class="form-label required">{{
                  "Times of Day (HH:mm)" | translate
                }}</label>
                <div
                  class="d-flex flex-wrap align-items-center gap-2 form-control mb-1"
                >
                  <span
                    *ngFor="
                      let t of formdata.get('schedule_times')?.value;
                      let ti = index
                    "
                    class="email-badge text-white d-flex align-items-center"
                  >
                    {{ t }}
                    <i
                      class="fa-solid fa-xmark ms-2"
                      style="cursor: pointer"
                      (click)="removeScheduleTime(ti)"
                    ></i>
                  </span>
                  <input
                    type="text"
                    class="border-0 flex-grow-1 p-0"
                    style="min-width: 80px; outline: none"
                    formControlName="schedule_time_input"
                    placeholder="HH:mm"
                    (keydown.enter)="addScheduleTime()"
                  />
                </div>
                <small class="text-muted">
                  {{ "Type a time (e.g. 08:00) and press Enter" | translate }}
                </small>
              </div>
            </ng-container>
          </div>

          <!-- ─── Flags Row ──────────────────────────────────────────────────── -->
          <div class="row mt-3">
            <div class="col-md-3">
              <label class="form-label" for="status">{{
                "Single Punch" | translate
              }}</label
              >&nbsp;
              <input
                type="checkbox"
                class="form-check-input check_box_cursor"
                formControlName="single_punch"
              />
            </div>
            <div class="col-md-3">
              <label class="form-label" for="status">{{
                "Status" | translate
              }}</label
              >&nbsp;
              <input
                type="checkbox"
                class="form-check-input check_box_cursor"
                formControlName="status"
              />
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="mt-4 mb-4 container-fluid">
      <p-table
        id="fieldMappingTable"
        styleClass="p-datatable-gridlines"
        [value]="field_mapping_array.controls"
        [tableStyle]="{ 'min-width': '60rem' }"
      >
        <ng-template pTemplate="header">
          <tr>
            <th class="text-center tHead" style="width: 5%">S.No</th>
            <th class="tHead">Standard Field Name</th>
            <th class="tHead required">Company Field Key</th>
            <th class="tHead required">Company Field Key Format</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row let-i="rowIndex">
          <tr [formGroup]="row">
            <td class="text-center">{{ i + 1 }}</td>

            <!-- Standard Field Name -->
            <td class="">
              {{ row.get("standard_field_name")?.value }}
            </td>

            <!-- Company Field Key -->
            <td>
              <!-- If this row is a punch_array, show chip-style input like device_ids -->
              <ng-container
                *ngIf="
                  row.get('standard_field_key')?.value === 'punch_array';
                  else normalKeyInput
                "
              >
                <div
                  class="form-control d-flex flex-wrap align-items-center gap-2"
                  [ngClass]="{
                    'is-invalid':
                      row.get('company_field_key')?.invalid &&
                      (row.get('company_field_key')?.touched || saveClick),
                  }"
                >
                  <span
                    *ngFor="
                      let item of row.get('company_field_key')?.value;
                      let j = index
                    "
                    class="margin_top email-badge text-white d-flex align-items-center"
                  >
                    {{ item }}
                    <i
                      class="fa-solid fa-xmark ms-2"
                      (click)="removePunchItem(i, j)"
                      style="cursor: pointer"
                    ></i>
                  </span>

                  <input
                    #companyInputRef
                    type="text"
                    class="border-0 flex-grow-1 p-0"
                    style="min-width: 120px; outline: none"
                    [formControl]="companyFieldKeyInput"
                    (keydown.enter)="addPunchItem(i)"
                    [placeholder]="'Type and press Enter' | translate"
                    maxlength="30"
                  />
                </div>

                <app-validation-error
                  [control]="row.get('company_field_key')"
                  fieldName="Punch value"
                  [submit]="saveClick"
                ></app-validation-error>
              </ng-container>

              <ng-template #normalKeyInput>
                <input
                  type="text"
                  class="form-control"
                  maxlength="30"
                  formControlName="company_field_key"
                  [ngClass]="{
                    'is-invalid':
                      (row.get('company_field_key')?.hasError('required') &&
                        row.get('company_field_key')?.touched) ||
                      (row.get('company_field_key')?.hasError('pattern') &&
                        row.get('company_field_key')?.touched),
                  }"
                />

                <app-validation-error
                  [control]="row.get('company_field_key')"
                  fieldName="Company field key"
                  [submit]="saveClick"
                ></app-validation-error>
              </ng-template>
            </td>

            <!-- Company Field Key Format -->
            <td class="align-top">
              <!-- ✅ Show dropdown for fields that need a format -->
              <ng-container
                *ngIf="
                  !showIfenArray.includes(row.get('standard_field_key')?.value);
                  else noFormat
                "
              >
                <ng-select
                  [items]="fieldFormatOptions"
                  bindLabel="label"
                  bindValue="value"
                  placeholder="Select Format"
                  formControlName="company_field_key_format"
                  appendTo="body"
                  [clearable]="false"
                  [ngClass]="{
                    'is-invalid':
                      row.get('company_field_key_format')?.invalid &&
                      row.get('company_field_key_format')?.touched,
                  }"
                ></ng-select>

                <app-validation-error
                  [control]="row.get('company_field_key_format')"
                  fieldName="Company field key format"
                  [submit]="saveClick"
                ></app-validation-error>
              </ng-container>

              <!-- ✅ Show '---' for employee_code or punch_array -->
              <ng-template #noFormat>
                <span>---</span>
              </ng-template>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="5" class="text-center p-3">
              {{ "No Records Found" | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!-- Value Translation Configurator -->
    <div class="mt-4 mb-4 container-fluid">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h6 class="mb-0">{{ "Additional Field Mappings" | translate }}</h6>
        <div ngbDropdown class="d-inline-block">
          <button
            type="button"
            class="btn btn-sm submit dropdown-toggle"
            ngbDropdownToggle
          >
            <i class="fa-solid fa-plus me-1"></i>{{ "Add Field" | translate }}
          </button>
          <div ngbDropdownMenu class="dropdown-menu-end">
            <button
              *ngFor="let opt of optionalFieldKeyOptions"
              ngbDropdownItem
              type="button"
              (click)="addOptionalFieldRow(opt.value)"
            >
              {{ opt.label | translate }}
            </button>
          </div>
        </div>
      </div>

      <p-table
        styleClass="p-datatable-gridlines"
        [value]="optional_field_mapping_array.controls"
        [tableStyle]="{ 'min-width': '60rem' }"
      >
        <ng-template pTemplate="header">
          <tr>
            <th class="text-center tHead" style="width: 4%">S.No</th>
            <th class="tHead required">{{ "Standard Field" | translate }}</th>
            <th class="tHead required">{{ "Vendor Field Key" | translate }}</th>
            <th class="tHead">{{ "Vendor Format" | translate }}</th>
            <th class="tHead">{{ "Delimiter" | translate }}</th>
            <th class="text-center tHead" style="width: 8%">
              {{ "Action" | translate }}
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row let-i="rowIndex">
          <tr [formGroup]="row">
            <td class="text-center">{{ i + 1 }}</td>

            <!-- Standard Field Key dropdown -->
            <td>
              <ng-select
                [items]="optionalFieldKeyOptions"
                bindLabel="label"
                bindValue="value"
                [clearable]="false"
                [placeholder]="'Select field' | translate"
                formControlName="standard_field_key"
                appendTo="body"
                (change)="onOptionalKeyChange(i)"
                [ngClass]="{
                  'is-invalid':
                    row.get('standard_field_key')?.invalid &&
                    (row.get('standard_field_key')?.touched || saveClick),
                }"
              >
              </ng-select>
              <app-validation-error
                [control]="row.get('standard_field_key')"
                fieldName="Standard field"
                [submit]="saveClick"
              ></app-validation-error>
            </td>

            <!-- Vendor Field Key (chip input for punch_array, text otherwise) -->
            <td>
              <ng-container
                *ngIf="
                  row.get('standard_field_key')?.value === 'punch_array';
                  else optTextInput
                "
              >
                <div
                  class="form-control d-flex flex-wrap align-items-center gap-2"
                  [ngClass]="{
                    'is-invalid':
                      row.get('company_field_key')?.invalid &&
                      (row.get('company_field_key')?.touched || saveClick),
                  }"
                >
                  <span
                    *ngFor="
                      let item of row.get('company_field_key')?.value;
                      let j = index
                    "
                    class="email-badge text-white d-flex align-items-center"
                  >
                    {{ item }}
                    <i
                      class="fa-solid fa-xmark ms-2"
                      (click)="removeOptionalPunchItem(i, j)"
                      style="cursor: pointer"
                    ></i>
                  </span>
                  <input
                    type="text"
                    class="border-0 flex-grow-1 p-0"
                    style="min-width: 100px; outline: none"
                    [formControl]="optionalFieldKeyInputControl"
                    [placeholder]="'Type and press Enter' | translate"
                    (keydown.enter)="addOptionalPunchItem(i)"
                    maxlength="30"
                  />
                </div>
                <app-validation-error
                  [control]="row.get('company_field_key')"
                  fieldName="Vendor field key"
                  [submit]="saveClick"
                ></app-validation-error>
              </ng-container>

              <ng-template #optTextInput>
                <input
                  type="text"
                  class="form-control"
                  maxlength="50"
                  formControlName="company_field_key"
                  [ngClass]="{
                    'is-invalid':
                      row.get('company_field_key')?.invalid &&
                      (row.get('company_field_key')?.touched || saveClick),
                  }"
                />
                <app-validation-error
                  [control]="row.get('company_field_key')"
                  fieldName="Vendor field key"
                  [submit]="saveClick"
                ></app-validation-error>
              </ng-template>
            </td>

            <!-- Vendor Format (only for date/datetime fields; n/a for tna_io and punch_csv) -->
            <td>
              <ng-container
                *ngIf="
                  !showIfenArray.includes(row.get('standard_field_key')?.value);
                  else optNoFormat
                "
              >
                <ng-select
                  [items]="fieldFormatOptions"
                  bindLabel="label"
                  bindValue="value"
                  [placeholder]="'Select Format' | translate"
                  formControlName="company_field_key_format"
                  appendTo="body"
                  [clearable]="true"
                ></ng-select>
              </ng-container>
              <ng-template #optNoFormat><span>---</span></ng-template>
            </td>

            <!-- Delimiter (only relevant for punch_csv) -->
            <td>
              <ng-container
                *ngIf="
                  row.get('standard_field_key')?.value === 'punch_csv';
                  else noDelimiter
                "
              >
                <input
                  type="text"
                  class="form-control"
                  maxlength="5"
                  formControlName="company_field_key_delimiter"
                  placeholder=","
                />
              </ng-container>
              <ng-template #noDelimiter><span>---</span></ng-template>
            </td>

            <td class="text-center">
              <i
                class="fa-solid fa-trash text-danger"
                (click)="removeOptionalFieldRow(i)"
                style="cursor: pointer"
              ></i>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="6" class="text-center p-3">
              {{ "No additional mappings added" | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!-- Value Translation Configurator (shown only when a tna_io row exists) -->
    <div class="mt-4 mb-4 container-fluid" *ngIf="hasTnaIoRow">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h6 class="mb-0">{{ "Value Translations (Optional)" | translate }}</h6>
        <button
          type="button"
          class="btn btn-sm submit"
          (click)="addValueMapping()"
        >
          <i class="fa-solid fa-plus me-1"></i>
          {{ "Add Translation" | translate }}
        </button>
      </div>
      <p-table
        styleClass="p-datatable-gridlines"
        [value]="value_mapping_array.controls"
        [tableStyle]="{ 'min-width': '60rem' }"
      >
        <ng-template pTemplate="header">
          <tr>
            <th class="text-center tHead" style="width: 5%">S.No</th>
            <th class="tHead required">
              {{ "Vendor Punch Code" | translate }}
            </th>
            <th class="tHead required">
              {{ "System Equivalent (I / O)" | translate }}
            </th>
            <th class="text-center tHead" style="width: 10%">
              {{ "Action" | translate }}
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row let-i="rowIndex">
          <tr [formGroup]="row">
            <td class="text-center">{{ i + 1 }}</td>
            <td>
              <input
                type="text"
                class="form-control"
                formControlName="vendor_value"
                [placeholder]="'e.g. 0 or 255' | translate"
                [ngClass]="{
                  'is-invalid':
                    row.get('vendor_value')?.invalid &&
                    (row.get('vendor_value')?.touched || saveClick),
                }"
              />
              <app-validation-error
                [control]="row.get('vendor_value')"
                fieldName="Vendor Punch Code"
                [submit]="saveClick"
              ></app-validation-error>
            </td>
            <td>
              <select
                class="form-select"
                formControlName="system_value"
                [ngClass]="{
                  'is-invalid':
                    row.get('system_value')?.invalid &&
                    (row.get('system_value')?.touched || saveClick),
                }"
              >
                <option value="" disabled selected>Select System Code</option>
                <option value="I">I (Check In)</option>
                <option value="O">O (Check Out)</option>
              </select>
              <app-validation-error
                [control]="row.get('system_value')"
                fieldName="System Equivalent"
                [submit]="saveClick"
              ></app-validation-error>
            </td>
            <td class="text-center">
              <i
                class="fa-solid fa-trash text-danger"
                (click)="removeValueMapping(i)"
                style="cursor: pointer"
              ></i>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="4" class="text-center p-3">
              {{ "No Value Translations Added" | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!-- Submit Buttons -->
    <div class="mt-3 text-end">
      <button type="button" class="btn btn-sm cancel mx-3" (click)="onCancel()">
        {{ "Cancel" | translate }}
      </button>
      <button
        *ngIf="checkPermission(!paramValue ? 'save' : 'edit')"
        [disabled]="!formisDisable"
        type="button"
        class="btn submit btn-sm"
        (click)="formSubmit()"
      >
        {{ (!paramValue ? "create" : "Update") | translate }}
      </button>
    </div>
  </div>
</div>
